import { useState } from 'react'
import ConfirmDeleteMineral from './ConfirmDeleteMineral'
import { MdDelete } from 'react-icons/md'

export default function ButtonDeleteMineral({ mineralId, onClose }) {
  const [isOpen, setIsOpen] = useState(false)

  function handleOnOpenModel() {
    setIsOpen(true)
  }

  function handleOnCloseModel() {
    setIsOpen(false)
    onClose()
  }

  return (
    <>
      <button
        onClick={handleOnOpenModel}
        className="flex w-full items-center gap-4 border-2 border-danger-500 bg-danger-300 px-4 py-2 text-danger-700 hover:bg-danger-500 hover:text-white"
      >
        <MdDelete />
        <div>حذف</div>
      </button>
      <ConfirmDeleteMineral
        isOpen={isOpen}
        onClose={handleOnCloseModel}
        mineralId={mineralId}
      />
    </>
  )
}
